import React, { useState, useEffect, useCallback, useRef } from "react";

//routes
import { useParams } from "react-router-dom";

//components
import DataTable from "../../../../components/Tables/DataTable";

//hooks
import useLazyQueryAuth from "../../../../hooks/useLazyQueryAuth";
import useQueryAuth from "../../../../hooks/useQueryAuth";
import useAuth from "../../../../hooks/useAuth";
import useMutationAuth from "../../../../hooks/useMutationAuth";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";


//graphql
import {
  ASSIGN_PROJECTS_TO_RESOURCE,
  DELETE_PROJECTS,
  FAVORITE_TASK,
  GET_ALL_PROJECTS,
  GET_ALL_PROJECTS_STATUSES,
  UNASSIGN_PROJECTS_TO_RESOURCE,
} from "../../../../graphql/project";
//graphql
import {
  DELETE_PROJECT_PERMISSIONS_LIST,
} from "../../../../graphql/projectPermission";
import { GET_USER_TABLE_PREFERENCES } from "../../../../graphql/userTablePreferences";

//editors
import { Parse } from "../../../../JSON.editor";

//mnemonic values
import Mnemonic from "../../../../Mnemonics.json";

//urls
import urls from "../../../../urls";

//external components
import { CircularProgress, Card, Modal, IconButton } from "@mui/material";

import ContainerCard from "../../../../components/Cards/ContainerCard";
import UTC2Local, { formatDateTimeToString, UTC2Time } from "../../../../UTC2Local";
import componentDisplay from "../../../../componentDisplay";

import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import EmployeeTable from "../../Teams/Teams-list/EmployeeTable";
import { decodeUnicodeString } from "../../../../utils/decodeUnicodeString";
import { removeNullProps } from "../../../../utils/removeNullProps";
import { CloseIcon, DeleteIcon } from "../../../../components/Icon";
import { GET_ALL_TASKS_LIST, GET_FAVORITE_TASKS } from "../../../../graphql/task";
import { getTable } from "./table";
import AddFavoriteTaskModal from "./addFavoriteModal";
import ConfirmationModal from "../../../../components/Modal/ConfirmationModal";
import CustomButton from "../../../../components/CustomButton";
import colors from "../../../../assets/theme/light/colors";
import RowsSubrows from "../Tasks-list/RowsSubrows";
import TaskTabsModal from "../../../../components/Modal/TaskTabsModal";

const FavoriteTasks = ({ myCompany = false, fromTenant = false, fromFavorites = false, myEmployees = false, fromResource = false, setDisplay = () => { }, refetchProjects = () => { } }) => {
  const { tName, tID, eID, } = useParams();

  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const [fetchStatuses, setFetchStatuses] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const { storeUserGuid, storeUserTenant, userRoles } = useAuth();

  const { manageTimeEntry, manageUsers } = userRoles;
  const [displayTable, setDisplayTable] = useState(false);

  const [re, setRe] = useState(false);
  const [data, setData] = useState(null);
  const [defaultFilters, setDefaultFilters] = useState({});
  const [columns, setColumns] = useState([]);
  const [order, setOrder] = useState("");
  const [orderBy, setOrderBy] = useState("");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [search, setSearch] = useState("");
  const [openAddFav, setOpenAddfav] = useState(false);
  const [filterState, setFilterState] = useState([]);
  const [projectGuid, setProjectGuid] = useState("");
  const [columnOrder, setColumnOrder] = useState(
    [] //array of column ids (Initializing is optional as of v2.10.0)
  );
  const [response, setResponse] = useState(false);


  //   const {
  //     data: projectsList,
  //     loading: projectsLoading,
  //     tokenChange: projectsWait,
  //   } = useQueryAuth(GET_ALL_PROJECTS, "GetAllProjects");

  const { mfunction: getAllTasksList, loading: tasksListLoading, refetch: refetchTasks } =
    useLazyQueryAuth(GET_ALL_TASKS_LIST, "GetFilteredTasks");

  const [columnsLoaded, setColumnsLoaded] = useState(false);

  const {
    loading: getColumnsLoading,
    tokenChange: columnsWait,
    refetch,
  } = useQueryAuth(
    GET_USER_TABLE_PREFERENCES,
    "GetUserTablePreferences",
    {
      variables: {
        model: {
          table: Mnemonic.Tables.Tasks,
          userID: storeUserGuid,
        },
      },
      skip: columnsLoaded,
      isWait: tasksListLoading,
    },
    {
      onCompleted: (response) => {
        let col =
          response &&
          response.GetUserTablePreferences &&
          response.GetUserTablePreferences.columns
            ? response.GetUserTablePreferences.columns
            : null;

        if (col) {
          col = decodeUnicodeString(col);
          
          //we parse the json string to a json object
          const parsed = JSON.parse(col, (key, value) =>
            Parse(key, value, UTC2Local, componentDisplay, null, null, null, formatDateTimeToString)
          );

          if (parsed.columns) {
            let cols = parsed.columns;

            cols.map(c => {
              c = removeNullProps(c);
              return c;
            })
            setColumns(cols);
            setColumnsLoaded(true)
          }

          if (parsed.defaultSort) setOrderBy(parsed.defaultSort);

          if (parsed.defaultSortDirection)
            setOrder(parsed.defaultSortDirection);
        }
      },
    }
  );


  const offset = new Date().getTimezoneOffset() / -60;
  const fetchTableData = useCallback(
    (
      pageParam = 0,
      pageSizeParam = 20,
      orderParam = "",
      orderByParam = "",
      searchParam = "",
      filters = null,
      chipFilters = null
    ) => {
      
      getAllTasksList(
        {
          variables: {
            model: {
              keys: {
                page: pageParam + 1,
                pageSize: pageSizeParam,
              },
              enableFilters: true,
              filters: filters,
              tenantID: storeUserTenant,
              userID: storeUserGuid,
              keyWord: searchParam,
              favorites: true,
              orderDirection: orderParam,
              orderColumn: orderByParam,
              offset: offset,
            },
          },
        },
        (response) => {
          setData(response?.GetFilteredTasks?.tasksTreeResponse?.thisTaskViews || []);
          setResponse(response);
        }
      );
    },
    []
  );
  



  const handleRefresh = () => {
    fetchTableData(
      page || 0,
      rowsPerPage || 20,
      order,
      orderBy,
      search,
      defaultFilters || null,
    );
  };


  const { red_color } = colors;
  const customButtons = [
    {
      label: "Add Favorite Task",
      handleClick: () => { setOpenAddfav(true); },
      condition: (!selected || selected.length === 0),
      icon: true,
      iconButton: (
        <AddCircleRoundedIcon
          sx={{
            color: "var(--color--light-logo-blue)",
            fontSize: "28px !important"
          }}
        />
      ),
    },
    {
      label: "Delete Favorite Task",
      handleClick: () => { setOpenDialog(true); },
      condition: (selected.length > 0),
      icon: true,
      iconButton: (
        <DeleteIcon color={red_color}
          sx={{
            fontSize: "28px !important"
          }}
        />
      ),
    }
  ];

  useEffect(() => {
    if (!columnsWait) {
      fetchTableData(page, rowsPerPage, order, orderBy, search, defaultFilters);
    }
  }, [page, rowsPerPage, order, orderBy, defaultFilters, columnsWait]);


  const rows = response?.GetFilteredTasks?.tasksTreeResponse?.thisTaskViews;

  const numberOfRecords = response?.GetFilteredTasks?.tasksTreeResponse?.totalNumberOfRecords;
  const [taskID, setTaskID] = useState(null);
  const [taskName, setTaskName] = useState(null);
  const [projectID, setProjectID] = useState(null);
  const [projectName, setProjectName] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = (row) => {
    setTaskID(row?.task?.guid);
    setProjectID(row?.task?.projectGuid);
    setTaskName(row?.task?.title);
    setProjectName(row?.task?.projectName);
    setOpenModal(true);
  };

  const pagination = {
    rows,
    columns,
    order,
    setOrder,
    orderBy,
    setOrderBy,
    selected,
    setSelected,
    fetchTableData,
    onColumnOrderChange: setColumnOrder,
    defaultFilters,
    setDefaultFilters,
    search,
    columnOrder,
    setSearch,
    setPage,
    setRowsPerPage,
    refetch,
    removeFilters: true,
    tableMnemonic: Mnemonic.Tables.Tasks,
    numberRecords: numberOfRecords,
    page,
    rowsPerPage,
    loading: tasksListLoading || columnsWait,
    searchText: "Search By Task",
    customButtons: customButtons,
    handleOpenModal
  };



  const [openDialog, setOpenDialog] = useState(false);

  const { cfunction: favoriteTaskk } = useMutationAuth(
    FAVORITE_TASK,
    "EditTaskFavorites"
  );

  const handleUnfavoriteTask = () => {
    favoriteTaskk(
      {
        variables: {
          model: {
            addToFavorites: false,
            employeeGuid: storeUserGuid,
            taskGuids: selected ? selected.map(task => task.guid) : [],
          },
        },
      },
      (response) => {
        if (response["EditTaskFavorites"].editTaskQuickResponse === true) {
          enqueueSnackbar(t("Removed"), {
            variant: "success",
          });
          handleCloseDialog();
          refetchTasks()
          setSelected([])
        }
      },
      (error) => {
        enqueueSnackbar(t("Error removing the task as favorite"), {
          variant: "success",
        });
        handleCloseDialog()
        setSelected([])
      }
    );
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
  }

  const customModalButtons = () => (
    <>
      <CustomButton onClick={handleUnfavoriteTask} label={t("dialog.yes")} />
      <CustomButton onClick={handleCloseDialog} label={t("dialog.no")} />
    </>
  );

  const type = useRef("task");
  return (
    <div>
      {getColumnsLoading ? (
        <ContainerCard
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <CircularProgress />
        </ContainerCard>
      ) : (
        <>
          <DataTable {...pagination} identifier={"task"} hasCheckbox />
          <AddFavoriteTaskModal refetch={refetchTasks} t={t} openDialog={openAddFav} handleClose={() => setOpenAddfav(false)} />
          <ConfirmationModal
            contentText={t("Are you sure you want to unfavorite this task?")}
            title={t("dialog.warning")}
            icon={"warning"}
            openDialog={openDialog}
            handleClose={() => setOpenDialog(false)}
            customButtons={customModalButtons}
            t={t}
          />
          <TaskTabsModal
            showModal={openModal}
            setShowModal={(v) => setOpenModal(v)}
            loading={tasksListLoading}
            projectID={projectID}
            projectName={projectName}
            taskID={taskID}
            handleChangeProject={(v) => setProjectID(v)}
            handleChangeTask={(v) => setTaskID(v)}
            taskName={taskName}
            refetch={refetchTasks}
            fromProject={true}
            setType={(v) => type.current = v}
            type={type.current}
            open={JSON.parse(sessionStorage.getItem("unsavedChanges"))}
            modifyFormFlag={() =>
              sessionStorage.setItem("unsavedChanges", JSON.stringify(false))
            }
          />
        </>
      )}
    </div>
  );
};

export default FavoriteTasks;
